/**
 * One file per resource (plan §2). A new endpoint is a new file here plus one
 * line on `NookClient` — never an edit to `http.ts`.
 */
import { healthResponseSchema } from "@nook/schema";
export function getHealth(http) {
    return http.request({ path: "/health", schema: healthResponseSchema });
}
//# sourceMappingURL=health.js.map